<template>
  <aside class="sidebar">

    <ul class="nav">

      <sidebar-type-establishment v-if="isEstableshiment"
                                  :user="user" />

      <sidebar-type-admin v-if="isAdmin"
                          :admin="admin" />

      <sidebar-type-partner v-if="isLoggedPartner"
                            :user="user" />

      <app-sidebar-item v-if="admin && user"
                        :data-title="$t('message.generics.message.admin')"
                        data-icon="mdi-account-key-outline"
                        @click="goBackToken"
                        data-link=""></app-sidebar-item>

      <app-sidebar-item v-if="!isLoggedPartner && hasPartner && !admin"
                        :data-title="$t('message.admGenerics.message.partner')"
                        data-icon="mdi-account-key-outline"
                        @click="goBackToken"
                        data-link=""></app-sidebar-item>

    </ul>

    <sidebar-help v-if="helpLinkInfo"
                  :info="helpLinkInfo" />

  </aside>
</template>

<script>
import AppSidebarItem from "./item/SidebarItem";
import SidebarHelp from "./help/SidebarHelp";
import SidebarTypeEstablishment from "./type/establishment/SidebarTypeEstablishment";
import SidebarTypeAdmin from "./type/admin/SidebarTypeAdmin";
import SidebarTypePartner from "./type/partner/SidebarTypePartner";

import jwtDecode from "jwt-decode";
import { redirectUtils } from "@packages/util/redirect/redirectUtils";

export default {
  components: {
    AppSidebarItem,
    SidebarHelp,
    SidebarTypeAdmin,
    SidebarTypeEstablishment,
    SidebarTypePartner,
  },

  data() {
    return {};
  },

  mixins: [],

  computed: {
    isAdmin() {
      return !!this.admin && !this.user;
    },

    helpLinkInfo() {
      const currentRoutePath = this.$route.name;

      return {
        Statistics: {
          text: this.$t("message.sidebar.message.doubtsAboutStatistics"),
          link: "https://ajuda.wifeed.com.br/pt-BR/articles/6387540-entendendo-cada-metrica-das-estatisticas",
        },
        Advertising: {
          text: this.$t("message.sidebar.message.learnCreateCampaign"),
          link: "https://ajuda.wifeed.com.br/pt-BR/articles/6395865-criar-campanha",
        },
        INTERACTIONS: {
          text: this.$t("message.sidebar.message.accessFileDimensions"),
          link: "https://ajuda.wifeed.com.br/pt-BR/articles/6393370-dimensoes-de-arquivo-e-margem-de-seguranca",
        },
        Locals: {
          text: this.$t("message.sidebar.message.organizeLocalsAndAps"),
          link: "https://ajuda.wifeed.com.br/pt-BR/articles/6385190-criar-grupo-local-e-aparelho",
        },
      }[currentRoutePath];
    },

    user() {
      return this.$store.state.users.user;
    },

    admin() {
      return this.$store.state.users.admin;
    },

    hasPartner() {
      return this.$store.state.users.parceiro;
    },

    isLoggedPartner() {
      return (
        this.$store.state.users.user !== null &&
        this.$store.state.users.user.tipo === "PARCEIRO"
      );
    },

    permissions() {
      return this.$store.state.users.user.permissions;
    },

    isEstableshiment() {
      return (
        this.$store.state.users.user !== null &&
        this.$store.state.users.user.tipo === "ESTABELECIMENTO"
      );
    },
  },

  methods: {
    async goBackToken() {
      const userData = await this.$api.auth.goBackToken();
      localStorage.setItem("token", userData.token);
      const resultToken = jwtDecode(userData.token);
      this.$store.commit("SET_AVATAR", sessionStorage.getItem("avatar"));
      this.$store.commit("SET_LOGIN_AS", false);
      localStorage.setItem("loginAs", false);

      if (resultToken.accountType === "PARCEIRO") {
        this.$store.commit("SET_USER", {
          accountId: resultToken.accountId,
          avatar: userData.avatar,
          id: resultToken.userId,
          login: resultToken.sub,
          logo: userData.logo ? userData.logo : "",
          nome: resultToken.userName,
          paginaPosAutenticacao: userData.paginaPosAutenticacao,
          permissions: resultToken.permissions,
          isVivoAccount: userData.isVivoAccount,
          tipo: resultToken.accountType,
        });
        location.assign(redirectUtils.mountUrl('/new/parceiro/estabelecimentos'));
      } else {
        this.$store.commit("SET_USER", "");
        location.assign(redirectUtils.mountUrl('/new/admin/estabelecimentos'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  z-index: 1;
  background-color: white;
  justify-content: space-between;
  overflow-y: scroll;

  position: sticky;
  top: calc(13vh + 15px);

  @media (max-width: $desktop-md-max) {
    top: calc(15vh + 14px);
  }

  .nav {
    width: 100%;
    padding-left: 0;

    // this is required to fill grid gap with white
    margin-top: -20px;
    padding-top: 20px;
    background-color: inherit;
  }
}
</style>
